import React from "react";
import { Col, Form } from "react-bootstrap";

export const CustomInput = ({
  label,
  as = "input",
  options = [],
  type,
  ...rest
}) => {
  // For checkboxes, React-Bootstrap expects Form.Check
  if (type === "checkbox") {
    return (
      <Form.Group as={Col} className="mt-3">
        <Form.Check type="checkbox" label={label} {...rest} />
      </Form.Group>
    );
  }

  // For selects, pass options as children
  if (as === "select") {
    return (
      <Form.Group as={Col} className="mt-3">
        <Form.Label>{label}</Form.Label>
        <Form.Select {...rest}>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    );
  }

  // For textarea
  if (as === "textarea") {
    return (
      <Form.Group as={Col} className="mt-3">
        <Form.Label>{label}</Form.Label>
        <Form.Control as="textarea" {...rest} />
      </Form.Group>
    );
  }

  // Default input (text, number, etc.)
  return (
    <Form.Group as={Col} className="mt-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control type={type || "text"} {...rest} />
    </Form.Group>
  );
};
